package one.healthium.insights.domain.models

data class CardModel(
    val title: String,
    val thumbUrl: String,
    val action: ActionModel,
)